import styled, { css } from "styled-components";

export const Wrapper = styled.div`
	${({ theme }) => css`
		width: 100%;
		background-color: #fff;
		border-radius: 8px;
		margin-bottom: 12px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
		display: flex;
		font-family: "Poppins", sans-serif;
		overflow: hidden;
		transition: box-shadow 0.2s ease;

		&:hover {
			box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
		}

		${theme.breakpoints.down("xs")} {
			flex-direction: column;
		}
	`}
`;

export const ImageArea = styled.div`
	${({ theme }) => css`
		width: 210px;
		min-width: 210px;
		height: 160px;
		background-color: #fff;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 12px 16px;
		flex-shrink: 0;

		img.car-img {
			display: block;
			max-width: 100%;
			max-height: 100%;
			object-fit: contain;
			margin: auto;
		}

		img.placeholder {
			width: 64px;
			height: 64px;
			object-fit: contain;
			opacity: 0.2;
		}

		${theme.breakpoints.down("xs")} {
			width: 100%;
			min-width: unset;
			height: 170px;
		}
	`}
`;

export const InfoSection = styled.div`
	${({ theme }) => css`
		flex: 1;
		padding: 16px 20px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		gap: 10px;
		min-width: 0;

		.car-header {
			display: flex;
			align-items: center;
			gap: 10px;
			flex-wrap: wrap;

			.company-logo {
				max-width: 60px;
				max-height: 28px;
				object-fit: contain;
			}

			.car-name {
				font-size: 16px;
				font-weight: 600;
				color: #1a1a1a;
				line-height: 1.2;
			}

			.car-model {
				font-size: 13px;
				font-weight: 400;
				color: #888;
			}
		}

		.category-badge {
			display: inline-block;
			align-self: flex-start;
			background-color: #eef2ff;
			color: #4361ee;
			font-size: 11px;
			font-weight: 500;
			padding: 3px 10px;
			border-radius: 20px;
			line-height: 1.4;
		}

		.specs-row {
			display: flex;
			flex-wrap: wrap;
			gap: 6px;
		}

		.locations {
			display: flex;
			flex-direction: column;
			gap: 6px;
			margin-top: 2px;
		}

		${theme.breakpoints.down("xs")} {
			padding: 14px 16px;
		}
	`}
`;

export const SpecChip = styled.span`
	display: inline-flex;
	align-items: center;
	gap: 5px;
	background-color: #f3f4f6;
	color: #4b5563;
	font-size: 12px;
	font-weight: 400;
	padding: 4px 10px;
	border-radius: 20px;
	white-space: nowrap;
	line-height: 1.3;

	img {
		width: 14px;
		height: 14px;
		object-fit: contain;
		opacity: 0.65;
	}
`;

export const LocationRow = styled.div`
	${({ theme, variant }) => css`
		display: flex;
		align-items: flex-start;
		gap: 8px;
		font-size: 12px;
		line-height: 1.4;

		.dot {
			width: 8px;
			height: 8px;
			min-width: 8px;
			border-radius: 50%;
			margin-top: 4px;
			background-color: ${variant === "pickup" ? "#22c55e" : "#ef4444"};
		}

		.location-info {
			display: flex;
			flex-direction: column;
		}

		.location-label {
			font-weight: 500;
			color: #6b7280;
			font-size: 11px;
			text-transform: uppercase;
			letter-spacing: 0.3px;
		}

		.location-time {
			font-weight: 600;
			color: #1a1a1a;
			font-size: 13px;
		}

		.location-address {
			color: #6b7280;
			font-size: 12px;
			margin-top: 1px;
		}

		${theme.breakpoints.down("xs")} {
			.location-address {
				font-size: 11px;
			}
		}
	`}
`;

export const FareRow = styled.div`
	display: flex;
	align-items: center;
	gap: 5px;
	margin-top: 6px;

	.fare-name {
		font-size: 12px;
		color: #4b5563;
		line-height: 1.3;
		flex: 1;
	}

	.fare-info-icon {
		font-size: 15px !important;
		color: #9ca3af;
		flex-shrink: 0;
		cursor: pointer;

		&:hover {
			color: #6b7280;
		}
	}
`;

export const PaidOnDestinationNotice = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	background-color: #fffbeb;
	border-left: 3px solid #f59e0b;
	border-radius: 4px;
	padding: 6px 10px;
	margin-top: 8px;
	font-size: 11px;
	color: #92400e;
	line-height: 1.4;

	.notice-label {
		flex: 1;
		font-weight: 400;

		strong {
			font-weight: 600;
			margin-left: 3px;
		}
	}
`;

export const PricePanel = styled.div`
	${({ theme }) => css`
		width: 165px;
		min-width: 165px;
		border-left: 1px solid #e8e8e8;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: 16px 12px;
		gap: 8px;
		flex-shrink: 0;

		.company-logo-price {
			max-width: 70px;
			max-height: 30px;
			object-fit: contain;
			margin-bottom: 2px;
		}

		.price-amount {
			display: flex;
			align-items: baseline;
			gap: 3px;
			text-align: center;

			.currency-prefix {
				font-size: 13px;
				font-weight: 400;
				color: #1a1a1a;
			}

			.value {
				font-size: 22px;
				font-weight: 700;
				color: #1a1a1a;
				line-height: 1;
			}
		}

		.price-label {
			font-size: 11px;
			color: #888;
			text-align: center;
			line-height: 1.3;
		}

		.button-select {
			width: 100%;
			height: 38px;
			font-size: 13px;
			border-radius: 6px;
			margin: 0;
		}

		${theme.breakpoints.down("xs")} {
			width: 100%;
			min-width: unset;
			border-left: none;
			border-top: 1px solid #e8e8e8;
			flex-direction: row;
			flex-wrap: wrap;
			justify-content: center;
			padding: 14px 16px;

			.company-logo-price {
				display: none;
			}

			.price-amount {
				width: auto;
			}

			.price-label {
				width: auto;
				margin-right: 16px;
			}

			.button-select {
				width: auto;
				min-width: 120px;
			}
		}
	`}
`;
